//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class LetterNodeTypeService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[LetterNodeType.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-node-type/detail', {'params':params});
	};

	//GeneratorFlag:[LetterNodeType.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-node-type/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}